module.exports = __webpack_public_path__ + "media/question12_en.83d343d1.mp3";